export interface ExchangeRates {
  USD: number;
  EUR: number;
  CHF: number;
}

export async function fetchExchangeRates(): Promise<ExchangeRates> {
  try {
    // Using frankfurter.app - free, no API key needed
    const response = await fetch('https://api.frankfurter.app/latest?from=CHF&to=USD,EUR');
    const data = await response.json();
    
    // Convert to rates FROM other currencies TO CHF
    return {
      USD: 1 / data.rates.USD, // How many CHF per 1 USD
      EUR: 1 / data.rates.EUR, // How many CHF per 1 EUR
      CHF: 1 // CHF to CHF
    };
  } catch (error) {
    console.error('Failed to fetch exchange rates:', error);
    // Fallback rates if API fails
    return {
      USD: 0.88,
      EUR: 0.95,
      CHF: 1
    };
  }
}

export function convertToCHF(amount: number, currency: string, rates: ExchangeRates): number {
  const rate = rates[currency as keyof ExchangeRates] || 1;
  return amount * rate;
}
